<template>
  <div class="filter-condition filterMain" :style="checkFilterOpen()">
    <div class="filter-conditionCon scroll-container" :class="{ 'isSailDates': showFilterCategory === 'sailDates' }">
      <div ref="conditionContainer" class="filter-conditionContainer js-smartScroll">
        <!-- 目的地 -->
        <div id="destination" :style="checkFilterCategoryShow('destinations')">
          <div class="filter-conditionItem-container new-filter-more" style="border-top: 1px solid #eee;padding:4px 14px;">
            <!-- 目的地 样式调整 -->
             <div class="filter-conditionItem-new" v-for="(destSubCategory, i) in groupSubCategoriesNewData" :key="('dest_i'+i)">
              <p class="conditionItem-title-new conditionItem-arrow-new">
                {{destSubCategory.subCategory}}
                <span>
                    <span class="item-to-open item-arrow" v-if="destSubCategory.show == false" @click="changeArrowState(i)">
                        <span>展开</span>
                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowUpIcon.png" alt="未展开">
                    </span>
                    <span class="item-to-close item-arrow" v-else @click="changeArrowState(i)">
                        <span>收起</span>
                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowUpIcon.png" alt="展开">
                    </span>
                </span>
              </p>
              <template v-if="destSubCategory.show">
              <div class="filter-conditionItem-container-new" v-for="(group, j) in getFilterGroupsNew(destSubCategory.subCategory)" :key="('dest_' + i + '_' + j)">
                <div class="destination-content-new">
                  <div class="product-name-new">
                      <div class="line-new"></div>
                      <div class=text-new>{{ group }}</div>
                  </div>

                  <div class="filter-conditionItem-container">
                      <div class="destination-content">
                        <!--                                  <div class="product-name">-->
                        <!--&lt;!&ndash;                                    <div class="line"></div>&ndash;&gt;-->
                        <!--                                    <div class=text>{{group}}</div>-->
                        <!--                                  </div>-->
                        <div class="conditionItem-con">
                          <div 
                          v-if="getDestinationsByGroupNew(group, destSubCategory.subCategory) && getDestinationsByGroupNew(group, destSubCategory.subCategory).length > 1"
                            class="conditionItem-name js-filterConditionBtn mar-style width-atuo"
                            :class="{ active: checkDestinationAllSelected(group, destSubCategory.subCategory), 
                              noactive: checkDestinationAllDisabled(group, destSubCategory.subCategory) }"
                            @click="onDestAllSelected(group, destSubCategory.subCategory)">
                            <span>全部</span>
                          </div>
                          <div v-for="(dest, k) in getDestinationsByGroupNew(group, destSubCategory.subCategory)"
                               :key="dest.filterCode+'_'+k"
                            class="conditionItem-name js-filterConditionBtn mar-style width-atuo"
                            :class="{ active: isSelected(dest.filterCode, 'destinations'), noactive: isDisabled(dest.filterCode, 'destinations') }"
                            @click="onFilterClick(dest.filterCode, 'destinations', dest.title, 'destinations')">
                            <span>{{ dest.title }}</span>
                                                                <div class="conditionItem-hotIcon" v-if="dest.isHot">
                                                                  <img src="https://resource.rcclchina.com.cn/cruiseSearch/mb_hot_icon.png">
                                                                </div>
                                                                <div class="conditionItem-hotIcon" v-if="dest.isNew">
                                                                  <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tagNew.png">
                                                                </div>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>

              </div>
              </template>
             </div>

          </div>
        </div>
        <!-- 出发港 -->
        <div id="sailPort" :style="checkFilterCategoryShow('departures')">
          <div class="filter-conditionItem-container" style="border-top: 1px solid #eee">
            <!--                        <p class="conditionItem-area"></p>-->
            <div class="departures-con" style="padding:25px 14px;">
              <div v-for="(departure, i) in departures" :key="i" class="conditionItem-name js-filterConditionBtn"
                style="width: 78px;margin-right: 0; "
                :class="{ active: isSelected(departure.filterCode, 'departures'), noactive: isDisabled(departure.filterCode, 'departures') }"
                @click="onFilterClick(departure.filterCode, 'departures', departure.title, 'departures')"
                data-type="sailPort">
                <span>{{ departure.title }}</span>
                                             <div class="conditionItem-hotIcon" v-if="departure.isHot">
                                                 <img src="https://resource.rcclchina.com.cn/cruiseSearch/mb_hot_icon.png">
                                             </div>
                                             <div class="conditionItem-hotIcon" v-if="departure.isNew">
                                                 <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tagNew.png">
                                             </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 出发时间 -->
        <div id="sailDate" :style="checkFilterCategoryShow('sailDates')" style="padding: 0">
          <div class="filterSailDateBox" style="border-top: 1px solid #eee">
            <div class="yearBox">
              <div class="item" v-for="(item, i) in months" :key="i" @click="switchSailDateYear(i)"
                :class="currentSailDateIndex === i ? 'checked' : ''">
                <span v-if="isYearSelected(item.year)" class="checked-icon"></span> {{ item.year }}
              </div>
            </div>
            <div class="monthBox" data-type="sailDate">
              <div v-for="i in 12" :key="i" class="item" :class="{
                selected: isSelected(getMonthFilter(i), 'sailDates') || getMonthFilter(i).isSubmit,
                noactive: isDisabled(getMonthFilter(i), 'sailDates') || !getShowMonth(i)
              }"
                @click="onSailDateFilterClick(getMonthFilter(i), 'sailDates', getMonthFilter(i), 'holidaySailDays')">
                <!--{{getMonthCN(i)}}-->
                {{ i }}月 
              </div>
            </div>
          </div>
        </div>

        <div :style="checkFilterCategoryShow('orderBy')">
          <div class="filter-sort js-sortBtn js-smallScroll" style="border-top: 1px solid #eee">
            <div v-for="(item, idx) in departTimeFilter" :key="idx" :class="{ active: item.isActive }"
              @click="onBindDepartItem(idx, item.key, item.gioDesc)">
              <span>{{ item.text }}</span>
              <div v-if="item.id !== 0">
                <a style="text-decoration: none;color: #666666" v-if="item.isActive">{{
                  item.showIconList[item.showIconIdx].text}}</a>
                <img :src="item.showIconList[item.showIconIdx].imgUrl" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 更多筛选 -->
        <div class="filter-More-box" :style="checkFilterCategoryShow('others')">
          <div class="filter-More-main" style="border-top: 1px solid #eee">
            <div class="moreBox">
              <div class="item" v-for="(item, i) in filterMore" :key="i" @click="switchFilterSide(item.id, item.gioDesc)"
                :class="{ checked: filterMoreSideIndex === i }">
                <span v-if="item.isActive" class="checked-icon"></span> {{ item.text }}
              </div>
            </div>
            <div>
              <div class="filter-more filterMoreRef" ref="filterMoreRef">
                <!-- 出行方式  -->
                <!-- <div class="filter-conditionItem anchor filterItemRef" >
                  <p class="conditionItem-title fontWeight">出行方式</p>
                  <div class="conditionItem-con">
                    <div class="conditionItem-name js-filterConditionBtn portItem" 
                    v-if="isShowTripModes('0')"
                    :class="{ active: isSelected('0', 'tripModes') }"
                    @click="onFilterClick('0', 'tripModes', '单船票', 'tripModes')"
                      >
                      <span>单船票</span></div>
                      <div class="conditionItem-name js-filterConditionBtn portItem" 
                      v-if="isShowTripModes('1')"
                      :class="{ active: isSelected('1', 'tripModes') }"
                      @click="onFilterClick('1', 'tripModes', '单船票', 'tripModes')"
                      >

                      <span>跟团游</span></div>
                  </div>
                </div> -->
                <!-- 行程晚数 -->
                <div class="filter-conditionItem anchor filterItemRef" id="sailDay">
                  <p class="conditionItem-title fontWeight">航程晚数</p>
                  <div class="conditionItem-con">
                    <div class="conditionItem-name js-filterConditionBtn"
                      @click="onFilterClick(3, 'sailDays', '3晚及以下', 'holidaySailDays')"
                      :class="{ active: isSelected(3, 'sailDays'), noactive: isDisabled(3, 'sailDays') }">
                      <span>3晚及以下</span></div>
                    <div class="conditionItem-name js-filterConditionBtn"
                      @click="onFilterClick(4, 'sailDays', '4晚', 'holidaySailDays')"
                      :class="{ active: isSelected(4, 'sailDays'), noactive: isDisabled(4, 'sailDays') }"><span>4晚</span>
                    </div>
                    <div class="conditionItem-name js-filterConditionBtn"
                      @click="onFilterClick(5, 'sailDays', '5晚', 'holidaySailDays')"
                      :class="{ active: isSelected(5, 'sailDays'), noactive: isDisabled(5, 'sailDays') }"><span>5晚</span>
                    </div>
                    <div class="conditionItem-name js-filterConditionBtn"
                      @click="onFilterClick(6, 'sailDays', '6晚及以上', 'holidaySailDays')"
                      :class="{ active: isSelected(6, 'sailDays'), noactive: isDisabled(6, 'sailDays') }">
                      <span>6晚及以上</span></div>
                  </div>
                </div>
                
                <!-- 出发港口 -->
                <div class="filter-conditionItem anchor filterItemRef" id="sailDay" v-if="departures.length > 0">
                  <p class="conditionItem-title fontWeight">出发港口</p>
                  <div v-for="(destSubCategory, i) in departuresSubCategories" :key="('dest_'+i)">
                    <div class="conditionItem-area-new">{{ destSubCategory }}</div>
                    <div class="conditionItem-con">
                      <template v-for="(departure, i) in departures">
                        <div v-if="departure.cruiseFilterGroupName == destSubCategory" :key="i+'dest_'" class="conditionItem-name js-filterConditionBtn portItem mar-style"
                          :class="{ active: isSelected(departure.filterCode, 'departures'), noactive: isDisabled(departure.filterCode, 'departures') }"
                          @click="onFilterClick(departure.filterCode, 'departures', departure.title, 'departures')"
                          data-type="sailPort">
                          <span>{{ departure.title }}</span>
                                                        <div class="conditionItem-hotIcon" v-if="departure.isHot">
                                                          <img src="https://resource.rcclchina.com.cn/cruiseSearch/mb_hot_icon.png">
                                                        </div>
                                                        <div class="conditionItem-hotIcon" v-if="departure.isNew">
                                                          <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tagNew.png">
                                                        </div>
                        </div>
                    </template>
                  </div>
                  </div>
                  
                </div>
                <!-- 游轮名称 -->
                <div class="filter-conditionItem open filterItemRef anchor" id="shipName">
                  <p class="conditionItem-title conditionItem-arrow js-openChoiceBtn fontWeight"
                    @click="onOpenGroupClick('shipCodes')">
                    游轮名称
                    <!--                            <span>-->
                    <!--                                    <span class="item-to-open item-arrow">-->
                    <!--                                        <span>展开</span>-->
                    <!--                                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowUpIcon.png" alt="未展开">-->
                    <!--                                    </span>-->
                    <!--                                    <span class="item-to-close item-arrow">-->
                    <!--                                        <span>收起</span>-->
                    <!--                                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowUpIcon.png" alt="展开">-->
                    <!--                                    </span>-->
                    <!--                                </span>-->
                  </p>
                  <div class="filter-conditionItem-container">
                    <!--                            <div v-for="(shipGroup, i) in getShipGroups()" :key="i">-->
                    <!--                              <p class="conditionItem-area">{{getShipGroupName(shipGroup)}}</p>-->
                    <div v-for="(destSubCategory, i) in shipSubCategories" :key="('des1t_'+i)" style="width: 100%;">
                      <div class="conditionItem-area-new">{{ destSubCategory }}</div>
                      
                      <div  class="conditionItem-con" >
                        <template v-for="(ship, i) in shipCodes">
                        <div
                        v-if="ship.cruiseFilterGroupName == destSubCategory" :key="i+'dest_123'"
                          class="conditionItem-name js-filterConditionBtn portItem mar-style"
                          :class="{ active: isSelected(ship.filterCode, 'shipCodes'), noactive: isDisabled(ship.filterCode, 'shipCodes') }"
                          @click="onFilterClick(ship.filterCode, 'shipCodes', ship.title, 'shipCodes')">
                          <span style="min-width: 80px !important;overflow: visible">{{ ship.title }}</span>
                                                            <div class="conditionItem-hotIcon" v-if="ship.isHot">
                                                              <img src="https://resource.rcclchina.com.cn/cruiseSearch/mb_hot_icon.png">
                                                            </div>
                                                            <div class="conditionItem-hotIcon" v-if="ship.isNew">
                                                              <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tagNew.png">
                                                            </div>
                        </div>
                        
                         </template>
                      </div>
                     
                    </div>

                    <!--                            </div>-->
                  </div>
                </div>
                <div class="filter-conditionItem anchor filterItemRef" id="tag" v-if="tags.length > 0">
                  <p class="conditionItem-title fontWeight">热门标签</p>
                  <div class="conditionItem-con">
                    <div class="conditionItem-name js-filterConditionBtn portItem" v-for="(item, idx) in tags"
                      :key="idx" @click="onFilterClick(item.tagType, 'tags', item.tagType, 'tagPromos')"
                      :class="{ active: isSelected(item.tagType, 'tags'), noactive: isDisabled(item.tagType, 'tags') }">
                      <span>{{ item.tagType }}</span></div>
                  </div>
                </div>
                <!-- 出发日期 -->
                <div class="filter-conditionItem anchor filterItemRef" id="sailDay" v-if="false">
                  <p class="conditionItem-title fontWeight">时间晚数 </p>
                  <p class="conditionItem-title">出发时间</p>
                  <div class="filterSailDateBox filterMoreDate">
                    <div class="yearBox">
                      <div class="item" v-for="(item, i) in months" :key="i" @click="switchSailDateYear(i)"
                        :class="currentSailDateIndex === i ? 'checked' : ''">
                        <!--                                <span v-if="isYearSelected(item.year)" class="checked-icon"></span>-->
                        {{ item.year }}
                      </div>
                    </div>
                    <div class="monthBox" data-type="sailDate">
                      <div v-for="i in 12" :key="i" class="item" :class="{
                        selected: isSelected(getMonthFilter(i), 'sailDates') || getMonthFilter(i).isSubmit,
                        noactive: isDisabled(getMonthFilter(i), 'sailDates')
                      }"
                        @click="onSailDateFilterClick(getMonthFilter(i), 'sailDates', getMonthFilter(i), 'holidaySailDays')">
                        <!--{{getMonthCN(i)}}-->
                        {{ i }}月
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 节庆假日  v-if="tagPromoList.length > 0" -->
                <div class="filter-conditionItem " id="sailDay" v-if="false">
                  <p class="conditionItem-title">节庆假日</p>
                  <div class="conditionItem-con">
                    <div class="conditionItem-name js-filterConditionBtn" v-for="(item, idx) in tagHolidayList"
                      :key="idx" @click="onFilterClick(item.tagType, 'tags', item.tagType, 'holidaySailDays')"
                      :class="{ active: isSelected(item.tagType, 'tags'), noactive: isDisabled(item.tagType, 'tags') }">
                      <span>{{ item.tagType }}</span></div>
                  </div>
                </div>
                
                <!-- 主题/联名房 v-if="themeList.length > 0"-->
                <div class="filter-conditionItem anchor open filterItemRef" id="tag" v-if="false">
                  <p class="conditionItem-title conditionItem-arrow js-openChoiceBtn fontWeight"
                    @click="onOpenGroupClick('tags')">
                    主题/联名房
                  </p>
                  <div class="filter-conditionItem-container">
                    <div v-for="(tag, i) in themeList" :key="i"
                      class="conditionItem-name js-filterConditionBtn portItem"
                      :class="{ active: isSelected(tag.tagType, 'tags'), noactive: isDisabled(tag.tagType, 'tags') }"
                      @click="onFilterClick(tag.tagType, 'tags', tag.tagType, 'tagTheme')">
                      <span>{{ tag.tagType }}</span>
                      <!--                              <div v-if="getTagFilter(tag.tagType).isHot" class="conditionItem-hotIcon">-->
                      <!--                                <img src="https://resource.rcclchina.com.cn/cruiseSearch/mb_hot_icon.png">-->
                      <!--                              </div>-->
                      <!--                              <div v-if="getTagFilter(tag.tagType).isNew"  class="conditionItem-hotIcon">-->
                      <!--                                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/tagNew.png">-->
                      <!--                              </div>-->
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="filterMoreSelect" class="filterMoreSelectBox" :style="moreSelectShow()"
        v-if="showFilterCategory !== 'orderBy'">
        <div class="label">已选：</div>
        <div class="content">
          <div class="contentItem" v-for="(filter, i) in getSelectedFiters()" :key="i"
            @click="onFilterRemove(filter.code, filter.key, filter.name)">
            <div class="text">{{ filter.key == 'departures' ? '出发港:' : '' }}{{ filter.name }}</div>
            <img class="icon" :src="`${imgUrl}/mobileSearchPackage/icon-closed-grey.png`" alt="" />
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="filterFooterBox" v-if="showFilterCategory !== 'orderBy'">
        <div class="itemBtn isReset" @click="onResetClick()">
          <span>清空选项</span>
        </div>
        <div class="itemBtn isSubmit" @click="onConfirmClick()">
          <span>查看航线</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { gioTracking } from "@/utilities/tools"
export default {
  name: 'SearchFilter',
  props: {
    cruiseFilters: {
      type: Array,
      default() {
        return []
      }
    },
    initSelectFilterCodes: {
      type: Object,
      default() {
        return {
          "departures": [],
          "destinations": [],
          "sailDates": [],
          "sailDays": [],
          "shipCodes": [],
          "tags": []
        }
      }
    },
    showFilterCategory: {
      type: String,
      default() {
        return ""
      }
    },
    months: {
      type: Array,
      default() {
        return []
      }
    },
    shipCodes: {
      type: Array,
      default() {
        return []
      }
    },
    departures: {
      type: Array,
      default() {
        return []
      }
    },
    destinations: {
      type: Array,
      default() {
        return []
      }
    },
    tags: {
      type: Array,
      default() {
        return []
      }
    },
    tagFilters: {
      type: Array,
      default() {
        return []
      }
    },
    filterConfirmHandler: {
      type: Function
    },
    tagPromoList: {
      type: Array,
      default() {
        return []
      }
    },
    themeList: {
      type: Array,
      default() {
        return []
      }
    },
    tagHolidayList: {
      type: Array,
      default() {
        return []
      }
    },
    emptyCondition: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      selectFilterCodes: [],
      currentSailDateIndex: 0,
      filterMoreSideIndex: 0,
      openedGroups: ['shipCodes', 'tags'],
      currCategory: "",
      filerMonths: [],
      filterMore: [
        // { id: 1, text: '出行方式', key: 'tripMode', isActive: false, type: 'tripMode', gioDesc: "CruiseSearchFilterDeparturePort" },
        { id: 1, text: '行程晚数', key: 'sailDays', isActive: false, type: 'holidaySailDays', gioDesc: "CruiseSearchFilterSailDateNights" },
        { id: 2, text: '出发港口', key: 'departures', isActive: false, type: 'departures', gioDesc: "CruiseSearchFilterDeparturePort" },
        { id: 3, text: '游轮名称', key: 'shipCodes', isActive: false, type: 'shipCodes', gioDesc: "CruiseSearchFilterShipCode" },
        // { id: 5, text: '目的地', key: 'destinations', isActive: false, type: 'destinations', gioDesc: "CruiseSearchFilterDestination" },
        // { id: 5, text: '主题/联名房', key: 'tags', isActive: false, type: 'tagTheme', gioDesc: "CruiseSearchFilterThemeRoom" }
        { id: 4, text: '热门标签', key: 'tags', isActive: false, type: 'tagPromos', gioDesc: "CruiseSearchFilterPromotion" },

      ],
      departTimeFilter: [
        {
          id: 0,
          text: '默认排序',
          isActive: true,
          showIconIdx: 0,
          key: 'orderBysailDate',
          type: 'orderBysailDate',
          gioDesc: "CruiseSearchSortDefault",
          showIconList: [
            { text: '', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDefault.png' },
            { text: '由近到远', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png' },
            { text: '由远到近', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png' }
          ]
        },
        {
          id: 1,
          text: '出发时间',
          isActive: false,
          showIconIdx: 0,
          key: 'orderBysailDate',
          gioDesc: "CruiseSearchSortSailDate",
          showIconList: [
            { text: '', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDefault.png' },
            { text: '由近到远', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png' },
            { text: '由远到近', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png' }
          ]
        },
        {
          id: 2,
          text: '航程晚数',
          isActive: false,
          showIconIdx: 0,
          key: 'orderBySailDays',
          gioDesc: "CruiseSearchSortSailingNights",
          showIconList: [
            { text: '', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDefault.png' },
            { text: '由少到多', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png' },
            { text: '由多到少', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png' }
          ]
        },
        {
          id: 3,
          text: '人均价格',
          isActive: false,
          showIconIdx: 0,
          key: 'orderByPrice',
          gioDesc: "CruiseSearchSortAPP",
          showIconList: [
            { text: '', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDefault.png' },
            { text: '由高到低', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png' },
            { text: '由低到高', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png ' }
          ]
        },
        {
          id: 4,
          text: '人均每晚价格',
          isActive: false,
          showIconIdx: 0,
          key: 'orderByAmountPerNight',
          gioDesc: "CruiseSearchSortAPD",
          showIconList: [
            { text: '', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDefault.png' },
            { text: '由高到低', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png ' },
            { text: '由低到高', imgUrl: 'https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png' }
          ]
        },
      ],
      isActiveTab: true,
      arr: [],
      filterItemRef: [],
      isScroll: false,
      groupSubCategoriesNewData:[]
    }
  },
  beforeMount() {
    this.initFilterData(this.initSelectFilterCodes)
  },
  mounted() {
    this.filterItemRef = document.getElementsByClassName('filterItemRef')
    let filterMoreRef = this.$refs.filterMoreRef
    filterMoreRef.addEventListener('scroll', this.handleScroll, true)
    // this.destinations()
  },
  beforeDestroy() {
    let filterMoreRef = this.$refs.filterMoreRef
    filterMoreRef.removeEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    
     
    // 展开 和收起
    changeArrowState(index){
      console.log(index)
      this.groupSubCategoriesNewData[index].show = !this.groupSubCategoriesNewData[index].show
    },
    // 初始化选中的条件
    initFilterData(initFilters) {
      let filters = []
      Object.keys(initFilters).forEach((key) => {
        if (key !== 'keywords') {
          if (key.indexOf("orderBy") >= 0) {
            filters.push({ code: initFilters[key], name: '', key: key })
          } else if (initFilters[key].length > 0) {
            initFilters[key].forEach((item) => {
              if (item.code && item.code.length > 0 || key == 'sailDays') {
                let name = item.name + ''
                if (!item.name) {
                  if (key == 'sailDays') {
                    if (item.code == 4) name = "4晚"
                    else if (item.code == 3) name = "3晚及以下"
                    else if (item.code == 5) name = "5晚"
                    else if (item.code > 5) name = "6晚及以上"
                  } else {
                    name = this.getFilterName(item.code)
                  }
                }
                filters.push({ code: item.code, name: name, key: key, type: item.type })
              }
            })
          }
        }
      })
      this.selectFilterCodes = filters

      this.selectFilterCodes.forEach(item => {
        this.departTimeFilter.forEach(x => {
          if (item.key === x.key) {
            if (item.code !== 0) {
              this.departTimeFilter[0].isActive = false
              if (x.type) {
                this.departTimeFilter[0].isActive = false
              } else {
                x.isActive = true
                x.showIconIdx = item.code
              }
            }
          }
        })
      })
    },
    // 判断条件是否已选中
    isSelected(code, key) {
      if (!code || code.length == 0) return false
      return this.selectFilterCodes.filter(r => r.code == code && r.key == key).length > 0
    },
    // 判断条件是否已禁用
    isDisabled(code, key) {
      // console.log(code,key)
      // console.log(this.$store.state.cruiseRow.filterResponse.hp,'hpppp')
      if (key == 'sailDays') {
        const filterResponse = this.$store.state.cruiseRow.filterResponse.hp['sailDays']
        code += 1
        if (code > 6) {
          return !(filterResponse.filter(r => r >= code).length > 0)
        } else {
          return !filterResponse.includes(code)
        }
      } else {
        if (!code || code.length == 0) return false
        const filterResponse = this.$store.state.cruiseRow.filterResponse.hp[key]
        if (typeof(code) == "string" && code.indexOf(',')>=0) {
                    return !filterResponse.some(r=> code.indexOf(r) >= 0)
                }
                return !filterResponse.includes(code)
      }

    },
    // 判断年份选择里面是否有选中的的月份
    isYearSelected(year) {
      let isSelected = false
      this.selectFilterCodes.forEach((item) => {
        if (item.key == 'sailDates') {
          if (item.code.indexOf(year) >= 0) {
            isSelected = true
          }
        }
      })
      return isSelected
    },
    // 点击某个条件
    onFilterClick(code, key, name, type) {
      // this.emptyCondition = true
      this.isActiveTab = true

      if (!code || code.length == 0 || !key || key.length == 0) return
      let data = {
        cruiseType: 'hp',
        key: key,
        type: type,
        values: []
      }
      const item = { code: code, name: name }
      data.values.push(item)

      if (this.isSelected(code, key)) {
        // 反选
        this.selectFilterCodes = this.selectFilterCodes.filter(r => r.code != code)
        // this.filterMore[id].isActive = false
        this.$store.dispatch('REMOVE_CRUISE_FILTERS_ROW', data)

      } else {

        if (this.isDisabled(code, key)) return
        this.selectFilterCodes.push({ code: item.code, name: item.name, key: key, type: type })
        // this.filterMore[id].isActive = true
        console.log('添加参数',data)
        this.$store.dispatch('SET_CRUISE_FILTERS_ROW', data)
      }
    },
    onFilterRemove(code, key, name) {
      if (key.indexOf('orderBy') < 0) {
        let data = {
          cruiseType: 'hp',
          key: key,
          values: [{ code: code, name: name }]
        }
        this.selectFilterCodes = this.selectFilterCodes.filter(r => r.code != code)
        this.$store.dispatch('REMOVE_CRUISE_FILTERS_ROW', data)
      } else {
        this.setOrderByValue('orderBysailDate', 1)
      }
    },
    // 根据展开的category, 获取已选中的条件
    getSelectedFiters() {
      if (this.showFilterCategory === 'sailDates') {
        return this.selectFilterCodes.filter(r => { if (r.key === 'sailDates') return r.name && r.name.length > 0 })
      }
      if (this.showFilterCategory === 'departures') {
        return ""
      }
      return this.selectFilterCodes.filter(r => r.name && r.name.length > 0)
      // const key = this.showFilterCategory
      // if (key == 'departures' || key == 'sailDates') {
      //     return this.selectFilterCodes.filter(r=>r.key == key && r.name && r.name.length > 0)
      // } else if (key == 'orderBy') {
      //     let activeOrderBy = this.selectFilterCodes.filter(r=>r.key.indexOf('orderBy') >= 0 && r.code > 0 && r.name && r.name.length > 0)
      //     return activeOrderBy && activeOrderBy.length > 0 ? activeOrderBy: []
      // }else {
      //     return this.selectFilterCodes.filter(r=>r.key != 'departures' && r.key != 'sailDates'
      //     && r.key != 'orderBy'
      //     && r.name && r.name.length > 0)
      // }
    },
    // 从页面cruise filters中获取code对应中文名
    getFilterName(code) {
      const items = this.cruiseFilters.filter(r => r.filterCode == code)
      return items.length > 0 ? items[0].title : ""
    },
    // 拼接月份
    getMonthFilter(num) {
      if (!this.months || !this.months[this.currentSailDateIndex]) {
        return ""
      }
      const year = this.months[this.currentSailDateIndex].year
      const month = num < 10 ? "0" + num : "" + num
      return year + '-' + month
    },
    getShowMonth(num){
      if (!this.months || !this.months[this.currentSailDateIndex]) {
        return false
      }
      return this.months[this.currentSailDateIndex].months.some(r => r.month == num)
    },
    // 检查筛选框是否打开
    checkFilterOpen() {
      return this.showFilterCategory.length > 0 ? { 'display': "block" } : { 'display': "none" }
    },
    // 检查筛选框分类是否打开
    checkFilterCategoryShow(category) {
      return this.showFilterCategory == category ? { 'display': "block" } : { 'display': "none" }
    },
    // 检查已选中是否显示
    moreSelectShow() {
      return this.getSelectedFiters().length > 0 ? { 'display': 'block' } : { 'display': 'none' }
    },
    onDestAllSelected(group, subCategory) {
      // const items = this.getDestinationsByGroup(group, subCategory)
      if (this.checkDestinationAllSelected(group, subCategory)) {
        // 如果已经选中，反选
        const items = this.getDestinationsByGroupNew(group, subCategory).map(r => r.filterCode)
        const selected = this.selectFilterCodes.filter(r => r.key == "destinations")
        const needRemove = selected.filter(r => items.includes(r.code))
        if (needRemove.length > 0) {
          let data = {
            cruiseType: 'hp',
            key: 'destinations',
            values: needRemove
          }
          this.selectFilterCodes = this.selectFilterCodes.filter(r => !items.includes(r.code))
          this.$store.dispatch('REMOVE_CRUISE_FILTERS_ROW', data)
        }
      } else {
        // 检查是否已经禁用
        if (this.checkDestinationAllDisabled(group, subCategory)) {
          return
        }
        // 取出没有被选中的，添加到selected中
        const selected = this.selectFilterCodes.filter(r => r.key == "destinations").map(r => r.code)
        const items = this.getDestinationsByGroupNew(group, subCategory).filter(r => !selected.includes(r.filterCode))

        if (items.length > 0) {
          let data = {
            cruiseType: 'hp',
            key: 'destinations',
            values: []
          }
          items.forEach((item) => {
            if (!this.isDisabled(item.code, 'destinations')) {
              this.selectFilterCodes.push({ code: item.filterCode, key: 'destinations', name: item.title })
              data.values.push({ code: item.filterCode, key: 'destinations' })
            }
          })
          this.$store.dispatch('SET_CRUISE_FILTERS_ROW', data)
        }
      }
    },
    // 替换目的地大类名称
    getSubCategoryName(subCategory) {
      if (subCategory.indexOf('/') > 0) {
        return subCategory.split("/").join("<br/>")
      } else {
        return subCategory
      }
    },
    // 切换日历
    onSailDateIndexChange(index) {
      if (index < 0 || index > this.months.length - 1) {
        return
      }
      this.currentSailDateIndex = index
    },
    switchSailDateYear(index) {
      this.currentSailDateIndex = index
    },
    // 更多筛选
    switchFilterSide(idx, gioDesc) {
      console.log(idx,'idxidxidxidx')
      this.isScroll = true
      this.filterMoreSideIndex = idx -1
      gioTracking('track', 'evt_ButtonClicked', {
        'btnType': gioDesc
      })
      //   跳转至指定的锚点class
      this.$nextTick(() => {
        const el = document.querySelectorAll('.anchor')[idx - 1];
        console.log(el,'elelel');
        
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setTimeout(() => {
            this.isScroll = false
          }, 1000);
        }
      });
    },
    onOpenGroupClick(category) {
      
      if (this.openedGroups.includes(category)) {
        this.openedGroups = this.openedGroups.filter(c => c != category)
      } else {
        this.openedGroups.push(category)
      }
      console.log(this.openedGroups)
    },
    onOrderByClick(key, code) {
      if (code <= 0 || code > 2) return
      this.setOrderByValue(key, code)
    },
    setOrderByValue(key, code) {
      let orderByValues = {
        orderBysailDate: 0,
        orderByPrice: 0,
        orderByAmountPerNight: 0,
        orderBySailDays: 0
      }
      orderByValues[key] = code
      const orderByFilterCodes = [{
        key: "orderBysailDate",
        code: orderByValues.orderBysailDate,
        name: this.getOrderByName('orderBysailDate', orderByValues.orderBysailDate)
      }, {
        key: "orderByPrice",
        code: orderByValues.orderByPrice,
        name: this.getOrderByName('orderByPrice', orderByValues.orderByPrice)
      }, {
        key: "orderByAmountPerNight",
        code: orderByValues.orderByAmountPerNight,
        name: this.getOrderByName('orderByAmountPerNight', orderByValues.orderByAmountPerNight)
      }, {
        key: "orderBySailDays",
        code: orderByValues.orderBySailDays,
        name: this.getOrderByName('orderBySailDays', orderByValues.orderBySailDays)
      },]
      this.selectFilterCodes = this.selectFilterCodes.filter(r => r.key.indexOf("orderBy") < 0).concat(orderByFilterCodes)
      console.log(this.selectFilterCodes)
    },
    onBindDepartItem(idx, key, gioDesc) {
      this.departTimeFilter[idx].isActive = true
      gioTracking('track', 'evt_ButtonClicked', {
        'btnType': gioDesc
      })
      for (let i = 0; i < this.departTimeFilter.length; i++) {
        if (i !== idx) {
          this.departTimeFilter[i].isActive = false
          this.departTimeFilter[i].showIconIdx = 0
        }
      }
      if (idx === 0) {
        this.setOrderByValue('orderBysailDate', 0)
        this.filterConfirmHandler(this.selectFilterCodes)
        return;
      }
      // 如果综合排序里这一项是激活状态，查看当前的showIconIdx，
      if (this.departTimeFilter[idx].isActive) {
        if (this.departTimeFilter[idx].showIconIdx === 2) {
          this.departTimeFilter[idx].showIconIdx = 1
        } else if (this.departTimeFilter[idx].showIconIdx === 1) {
          this.departTimeFilter[idx].showIconIdx = 2
        } else if (this.departTimeFilter[idx].showIconIdx === 0) {
          // 判断点击的是否是后面两个，如果是，则showIconIdx和前两个相反
          if (idx < 3) {
            this.departTimeFilter[idx].showIconIdx = 1
          } else {
            this.departTimeFilter[idx].showIconIdx = 2
          }
        }
      }
      if (this.departTimeFilter[idx].showIconIdx <= 0 || this.departTimeFilter[idx].showIconIdx > 2) return
      this.setOrderByValue(key, this.departTimeFilter[idx].showIconIdx)
      this.filterConfirmHandler(this.selectFilterCodes)
    },
    isOrderBySelected(key, code) {
      return this.selectFilterCodes.filter(r => r.key == key && r.code == code).length > 0
    },
    // 重置，去掉所有筛选
    onResetClick() {
      if (this.showFilterCategory === 'sailDates') {
        this.sailDatesResetClick(this.showFilterCategory)
        return;
      }
      this.selectFilterCodes = this.getDefaultOrderBy()
      this.$store.dispatch('INIT_CRUISE_FILTER_LIST_ROW', { cruiseType: "hp", data: [] })
      this.filterMore.forEach(item => {
        item.isActive = true
      })
      this.departTimeFilter.forEach(item => {
        if (item.id !== 0) {
          item.isActive = false
          item.showIconIdx = 0
        } else {
          item.isActive = true
        }
      })
      this.isActiveTab = false
    },
    onConfirmClick() {
      this.filterConfirmHandler(this.selectFilterCodes)
    },
    // 根据目的地分类获取目的地分组
    getFilterGroups(subCategory) {
      let groups = []
      this.destinations.forEach((destination) => {
        if (destination.countryName == subCategory
          && destination.countryName && destination.countryName.length > 0) {
          const groupName = destination.countryName
          if (!groups.includes(groupName)) {
            groups.push(groupName)
          }
        }
      })
      return groups
    },
    // 根据目的地分类获取目的地分组
        getFilterGroupsNew (subCategory) {
            let groups = []
            this.destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupSubCategory == subCategory
                    && destination.countryName && destination.countryName.length > 0) {
                        const groupName = destination.cruiseFilterGroupName
                        if (!groups.includes(groupName)) {
                            groups.push(groupName)
                        }
                    }
            })
            return groups
        },
        // 根据目的地分类和分组，获取所有目的地
        getDestinationsByGroupNew (group, subCategory) {
            let dests = this.destinations.filter(item =>
            item.cruiseFilterGroupSubCategory == subCategory && item.cruiseFilterGroupName == group)
            return _.orderBy(dests, 'seq')
        },
    // 根据目的地分类获取所有目的地
    getDestinationsBySubCategory(subCategory) {
      return this.destinations.filter(item => item.cruiseFilterGroupSubCategory == subCategory)
    },
    // 根据目的地分类和分组，获取所有目的地
    getDestinationsByGroup(group, subCategory) {
      let dests = this.destinations.filter(item =>
        item.countryName == group && subCategory)
      return _.orderBy(dests, 'seq')
    },
    // 检查全部按钮是否需要选中
    checkDestinationAllSelected(group, subCategory) {
      const dests = this.getDestinationsByGroupNew(group, subCategory).map(r => r.filterCode)
      const seleted = this.selectFilterCodes.filter(r => r.key == 'destinations').map(r => r.code)
      return dests.every(dest => seleted.includes(dest))
    },
    // 检查全部按钮是否需要禁用
    checkDestinationAllDisabled(group, subCategory) {
      const dests = this.getDestinationsByGroupNew(group, subCategory).map(r => r.filterCode)
      const availableItems = this.$store.state.cruiseRow.filterResponse['hp'].destinations
      return !availableItems.some(item => dests.includes(item))
    },
    getShipGroups() {
      let groups = []
      this.shipCodes.forEach((ship) => {
        if (ship.cruiseFilterGroupName && ship.cruiseFilterGroupName.length > 0) {
          if (ship.cruiseFilterGroupName.indexOf('超量子系列') < 0) {
            if (!groups.includes(ship.cruiseFilterGroupName)) {
              groups.push(ship.cruiseFilterGroupName)
            }
          }
        }
      })
      console.log(groups)
      return groups
    },
    getShipGroupName(group) {
      let items = group.split('|')
      let groupName = items[0].trim()
      if (items.length > 1) {
        groupName += "（" + items[1].trim() + "）"
      }
      return groupName
    },
    getShipsByShipGroup(shipGrop) {
      console.log(this.shipCodes)
      if (shipGrop.indexOf('量子') >= 0) {
        return this.shipCodes.filter(r => r.cruiseFilterGroupName.includes('量子'))
      } else {
        return this.shipCodes.filter(r => r.cruiseFilterGroupName == shipGrop)
      }
    },
    getTagFilter(tagType) {
      const tagFilter = this.tagFilters.filter(r => r.title == tagType)
      return tagFilter.length > 0 ? tagFilter[0] : {}
    },
    getOrderByName(key, value) {
      if (key == 'orderBysailDate') {
        if (value == 2) {
          return "出行日期从远到近"
        } else if (value == 1) {
          return "出行日期从近到远"
        }
      } else if (key == "orderByPrice") {
        if (value == 1) {
          return "人均价格从高到低"
        } else if (value == 2) {
          return "人均价格从低到高"
        }
      } else if (key == "orderBySailDays") {
        if (value == 1) {
          return "航程晚数从少到多"
        } else if (value == 2) {
          return "航程晚数从多到少"
        }
      } else if (key == "orderByAmountPerNight") {
        if (value == 1) {
          return "人均每晚起价从高到低"
        } else if (value == 2) {
          return "人均每晚起价从低到高"
        }
      }
      return ""
    },
    getDefaultOrderBy() {
      return [{
        key: 'orderBysailDate',
        code: 0,
        name: ''
      }, {
        key: 'orderByPrice',
        code: 0,
        name: ''
      }, {
        key: 'orderBysailDate',
        code: 0,
        name: ''
      }]
    },
    // 动态计算筛选框高度
    resizeCruiseFilterList() {
      var moreSelectH = this.$refs.filterMoreSelect.offsetHeight;
      if (moreSelectH <= 0) {
        moreSelectH = 0;
      }
      moreSelectH += 11; //padding的值

      var buttonHeight = 48;
      var conditionH = window.innerHeight - moreSelectH
        - 100 // header和筛选下拉的高度
        - buttonHeight;

      this.$refs.conditionContainer.style.maxHeight = conditionH + 'px'
    },
    getMonthCN(num) {
      switch (num) {
        case 1: return "一月";
        case 2: return "二月";
        case 3: return "三月";
        case 4: return "四月";
        case 5: return "五月";
        case 6: return "六月";
        case 7: return "七月";
        case 8: return "八月";
        case 9: return "九月";
        case 10: return "十月";
        case 11: return "十一月";
        case 12: return "十二月";
      }
    },
    //出发时间（重置）
    sailDatesResetClick(category) {
      // console.log(this.selectFilterCodes)
      this.selectFilterCodes = this.selectFilterCodes.filter(r => r.key != category);
      this.onConfirmClick();
    },
    //出发时间
    onSailDateFilterClick(code, key, name, type) {
      console.log(code, key, name)
      if (!code || code.length == 0 || !key || key.length == 0) return
      let data = {
        cruiseType: 'hp',
        key: key,
        values: []
      }
      let date = ''
      if (key === 'sailDates') {
        date = name.replace("-", '年') + '月';
      }
      const item = { code: code, name: date }
      data.values.push(item)

      if (this.isSelected(code, key)) {
        // 反选
        this.selectFilterCodes = this.selectFilterCodes.filter(r => r.code != code)
        this.$store.dispatch('REMOVE_CRUISE_FILTERS_ROW', data)
      } else {
        if (this.isDisabled(code, key)) return
        this.selectFilterCodes.push({ code: item.code, name: item.name, key: key, type: type })
        this.$store.dispatch('SET_CRUISE_FILTERS_ROW', data)
      }
      console.log(this.selectFilterCodes)
    },
    handleScroll() {
      if (this.isScroll) {
        return
      }
      let filterMoreRef = document.getElementsByClassName('filterMoreRef')
      const scrollPos = filterMoreRef[0].scrollTop;
      let newIndex = 0;
      for (let i = 0; i < this.filterItemRef.length; i++) {
        const sectionTop = this.filterItemRef[i].offsetTop;
        if (scrollPos >= sectionTop) {
          newIndex = i;
        } else {
          break;
        }
      }
      this.filterMoreSideIndex = newIndex;
    },
  },
  computed: {
    departuresSubCategories () {
            let groupSubCategories = []
            this.departures.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupName
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })

            return groupSubCategories
        },
    shipSubCategories () {
            let groupSubCategories = []
            this.shipCodes.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupName
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })

            return groupSubCategories
        },
    destinationSubCategories() {
      let groupSubCategories = []
      this.destinations.forEach((filter) => {
        const subCategory = filter.countryName
        if (!groupSubCategories.includes(subCategory)) {
          groupSubCategories.push(subCategory)
        }
      })
      return groupSubCategories
    },

    destinationSubCategoriesNew () {
            let groupSubCategories = []
            this.destinations.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupSubCategory
                if (!groupSubCategories.some(v=> v.subCategory == subCategory)) {
                    groupSubCategories.push({
                      subCategory:subCategory,
                      show:true
                    })
                }
            })
            return groupSubCategories
        },
     
    isShowTripModes(){
      return (num)=>{
        if(!this.$store.state.cruiseRow.filterResponse.hp || !this.$store.state.cruiseRow.filterResponse.hp.tripModes){
          return false
        }
        // console.log(this.$store.state.cruiseRow.filterResponse.hp.tripModes,'this.$store.state.cruiseRow.filterResponse.hp.tripModes')
        return this.$store.state.cruiseRow.filterResponse.hp.tripModes.indexOf(num) >= 0
      }
    },
    
  },
  watch: {
    initSelectFilterCodes(newOne) {
      this.initFilterData(newOne)
      this.selectFilterCodes.forEach(item => {
        this.filterMore.forEach(x => {
          let arr = []
          if (item.key === x.key) {
            arr.push(item.key)
            x.isActive = arr.indexOf(x.key) !== -1;
          }
        })
      })
      // if(this.initSelectFilterCodes.orderBysailDate===0){
      //   this.departTimeFilter.forEach(item=>{
      //     if(item.id!==0){
      //       item.isActive = false
      //       item.showIconIdx = 0
      //     }else{
      //       item.isActive = true
      //     }
      //   })
      // }
    },
    showFilterCategory(newOne, oldOne) {
      const self = this
      if (newOne != oldOne) {
        if (newOne.length > 0) {
          if (this.showFilterCategory === 'sailDates') {
            this.filerMonths = this.months;
          }
        }
        if (newOne.length == 0) {
          this.$store.dispatch('HIDE_HEADER_BAR_ROW', { isHideHeader: false, isHideFooter: false })
        } else {
          setTimeout(function () {
            self.resizeCruiseFilterList()
          }, 100)
          this.$store.dispatch('HIDE_HEADER_BAR_ROW', { isHideHeader: false, isHideFooter: false })
        }
      }
    },
    destinations(newValue) {
      // 自动展开目的地第一项，游轮和标签
      const destSubCategory = this.destinationSubCategories
      destSubCategory.forEach(item => {
        if (item && item.length > 0) {
          this.openedGroups.push(item)
        }
      })
      // if (destSubCategory && destSubCategory.length > 0) {
      //     this.openedGroups.push(destSubCategory)
      // }

      
      newValue.forEach((filter) => {
        const subCategory = filter.cruiseFilterGroupSubCategory
        if (!this.groupSubCategoriesNewData.some(v=> v.subCategory == subCategory)) {
            this.groupSubCategoriesNewData.push({
              subCategory:subCategory,
              show:true
              })
          }
        })

    },
    tags(newValue) { 
      // tag 标签 tag 数量为空的时候，删除tag
      if(newValue.length < 1){
        let index = this.filterMore.findIndex(item=>item.key=='tags')
        this.filterMore.splice(index,1)
      }
    },

    selectFilterCodes(newOne) {
      this.resizeCruiseFilterList()
      let tagsNum = 0
      // let tripModesNum = 0
      let departuresNum = 0
      let shipCodesNum = 0
      let sailDaysNum = 0
      // let destinationsNum = 0
      // let discountsNum = 0
      newOne.forEach(item => {
        if (item.type === 'tags') {
          tagsNum++
        } else if (item.type === 'departures') {
          departuresNum++
        } else if (item.type === 'shipCodes') {
          shipCodesNum++
        } else if (item.type === 'holidaySailDays') {
          sailDaysNum++
        } 
        // else if (item.type === 'destinations') {
        //   destinationsNum++
        // } else if (item.type === 'tagTheme') {
        //   discountsNum++
        // }
        // else if (item.type === 'tripModes') {
        //   tripModesNum++
        // }
      })

      // console.log(this.filterMore,'this.filterMorethis.filterMore')
      // this.filterMore[0].isActive = tripModesNum > 0
      if(this.filterMore[0]){
        this.filterMore[0].isActive = sailDaysNum > 0
      }
      if(this.filterMore[1]){
        this.filterMore[1].isActive = departuresNum > 0
      }
      if(this.filterMore[2]){
        this.filterMore[2].isActive = shipCodesNum > 0
      }
      if(this.filterMore[3]){
        this.filterMore[3].isActive = tagsNum > 0
      }

    },
    emptyCondition(newOne) {
      this.isActiveTab = newOne
    },
  }
}
</script>
<style lang="less" scoped>
@primary-color: #4C90E1;
@year-tab-bg: #F7F7F7;
@reset-btn-color: #EEEEEE;
@border-color: #E5E5E5;

.filterMain {
  position: fixed;
  top: 87px;
  left: 0;
  bottom: 0;
}

.filterSailDateBox {
  display: grid;
  //padding: 0 !important;
  grid-template-columns: 83px calc(100% - 83px);

  & .yearBox {
    background-color: @year-tab-bg;

    & .item {
      width: 83px;
      height: 42px;
      line-height: 42px;
      font-size: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      position: relative;

      &.checked {
        background: #FFFFFF;
        color: @primary-color;
      }

      &.selected::before {
        content: " ";
        position: absolute;
        top: 50%;
        left: 28rpx;
        margin-top: -3rpx;
        height: 6rpx;
        width: 6rpx;
        background: @primary-color;
      }
    }

    .checked-icon {
      position: absolute;
      top: 50%;
      left: 14px;
      transform: translate(0, -50%);
      display: inline-block;
      width: 3px;
      height: 3px;
      background-color: #4C91E2;
      border-radius: 50%;
    }
  }

  & .monthBox {
    width: 100%;
    padding: 10px;
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-rows: max-content;
    gap: 5px;

    & .item {
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      text-align: center;
      width: 80px;
      background-color: #EEEEEE;

      &.noactive {
        color: #dddddd;
        background-color: #FAFAFA;
      }

      &.selected {
        color: #FFFFFF;
        background-color: @primary-color;
      }
    }
  }
}

.filterFooterBox {
  display: flex;
  gap: 0 13px;
  height: 60px;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 9;
  border-top: 1px solid @border-color;
  background-color: white;

  & .itemBtn {
    width: 164px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 5px;
    font-size: 13px;

    &.isSubmit {
      color: #FFFFFF;
      background-color: @primary-color;
    }

    &.isReset {
      color: #666666;
      background-color: @reset-btn-color;
    }
  }
}

.filter-More-box {
  & .filter-More-main {
    display: flex;

    .moreBox {

      //background-color: @year-tab-bg;
      & .item {
        width: 93px;
        height: 42px;
        line-height: 42px;
        font-size: 12px;
        text-align: left;
        display: flex;
        align-items: center;
        background-color: @year-tab-bg;
        //justify-content: center;
        gap: 7px;
        position: relative;
        padding-left: 19px;

        &.checked {
          background: #FFFFFF;
          color: @primary-color;
        }

        &.selected::before {
          content: " ";
          position: absolute;
          top: 50%;
          left: 28rpx;
          margin-top: -3rpx;
          height: 6rpx;
          width: 6rpx;
          background: @primary-color;
        }

        .checked-icon {
          position: absolute;
          top: 50%;
          left: 8px;
          transform: translate(0, -50%);
          display: inline-block;
          width: 3px;
          height: 3px;
          background-color: #4C91E2;
          border-radius: 50%;
        }
      }
    }

    & .filter-more {
      padding-left: 15px;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 370px;
    }
  }
}

.filterMoreSelectBox {
  padding: 12px 6px 10px;
  background: #FFFFFF;
  display: none;
  overflow: hidden;
  font-size: 12px;

  & .label {
    float: left;
    line-height: 20px;
  }

  & .content {
    max-height: 50px;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-flow: wrap;
    gap: 5px;

    & .contentItem {
      display: flex;
      align-items: center;
      box-sizing: border-box !important;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      border-radius: 12px;
      gap: 4px;
      border: 1px solid #EEEEEE;

      & .text {
        font-size: 12px;
        transform: scale(0.9);
      }

      & .icon {
        height: 10px;
        width: 10px;
      }
    }
  }
}

.new-filter-more { 
  padding-left: 15px;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 370px;
}
.conditionItem-area-new{
  width: 100%;
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    margin-bottom: 4px;
   padding-top: 4px;
   box-sizing: border-box;
}
.mar-style{
  margin-top: 6px;
}
.width-atuo{
  width: auto !important;
  & span{
    width: auto !important;
  }
}

.filter-conditionItem-new {
    overflow:hidden;
    padding-bottom: 15px;
}
.conditionItem-title-new {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #4A90E2;
    letter-spacing: 1px;
    padding-bottom: 5px;
    border-bottom: 1px solid #E5E5E5;
    margin: 10px 0px;
    overflow:hidden;
}
.conditionItem-arrow-new>span{
    display:inline-block;
    float:right;
    /* margin-top:8px; */
}
.conditionItem-arrow-new  span.item-arrow{
    color: #666;
    font-size: 12px;
}
.conditionItem-arrow-new  span.item-arrow img {
    width:14px;
}

.conditionItem-arrow-new  span.item-to-open img {
   transform: rotate(90deg);
}
.filter-conditionItem-container-new{
  overflow: hidden;
}
.destination-content-new{

}

.product-name-new{
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    margin-bottom: 0;
}

.line-new {
    display: inline-block;
    vertical-align: middle;
    width: 3px;
    height: 14px;
    background: #ffcd00;
    margin-right: 4px;
}

.text-new {
    display: inline-block;
    vertical-align: middle;
}
</style>
